import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { columns, exportDirectDepositColumns } from "./column";
import { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import "./Listing.css";
import { Search } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import {
  getenrollmentlist,
  exportToExcelDirectDepositListings,
} from "../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { CustomExcelExport } from "../common/CustomExcelExport";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";

const customStyle = {
  table: {
    style: {
      border: "1px solid #DEDEDE",
      borderRadius: "5px",
      justifyContent: "center",
    },
  },
  header: {
    style: {
      color: "#193062",
    },
  },
  headRow: {
    style: {
      border: "none",
      backgroundColor: "#CDD4DC",
      fontWeight: "bold",
      color: "#002d82",
      fontSize: "14px",
      whiteSpace: "unset",
    },
  },
  rows: {
    stripedStyle: {
      backgroundColor: "#F2F3F5",
      justifyContent: "center",
    },
  },
};

function DirectDepositListing() {
  const navigate = useNavigate();
  const location = useLocation();
  const [records, setRecords] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setloading] = useState(false); //true
  const [exportEnrolledData, setExportEnrolledData]= useState([]);
  const [originalDownloadData, setOrgnlDownloadData]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [resetPagination, setRstPagination]= useState(false);
  
  //const [childCareFacility, setChildCareFacility] = useState("Child1");
  //const storetoken = useSelector((state) => state.storetoken);
  
  const storeuser = useSelector((state) => state.storeuser);
  const userAccessRole = useSelector((state) => state.userAccessRole);

 useEffect(() => {
  const getEnrollmentsListing = async() =>{
    setloading(true);
    try{
    const resp = await axiosInstance.get(`${getenrollmentlist}?userName=${storeuser.email}`);
    if(resp.data.isSuccess){
      setRecords(resp.data.result);
      setTableData(resp.data.result);
      setloading(false);
      seterrormodalOpen(false);
      }
      else if(!resp.data.isSuccess){
        seterrormodalOpen(true);
        setloading(false);
      }
   }
   catch (error) {
    console.log("Error occurred while getting enrollment list",error);
    seterrormodalOpen(true);
    setloading(false);
   }
  }
  getEnrollmentsListing();
 },[storeuser.email]);

 useEffect(() => {
  setloading(true);
  const getDataForDownload = async() =>{
    try{
      const resp = await axiosInstance.get(`${exportToExcelDirectDepositListings}${storeuser.email}`);
      if(resp.data.isSuccess){
      setExportEnrolledData(resp.data.result);
      setOrgnlDownloadData(resp.data.result);
      seterrormodalOpen(false);
      }
      else if(!resp.data.isSuccess){
        setloading(false);
        seterrormodalOpen(true);
      }
    }
    catch (err) {
      console.log("Error occurred while getting data to be downloaded",err.message);
      seterrormodalOpen(true);
      setloading(false);
    };
}

  getDataForDownload();
 },[storeuser.email]);

  const handleChangeInput = (e) => {
    let searchValue = false;
    let fname = false;
    let lname = false;
    let payee = false;
    let date = false;
    let time = false;
    let updatedBy = false;
    let updatedDate = false;

    //newdata serverdata
    const newdatas = tableData && tableData.filter((row) => {
      setRstPagination(!resetPagination);
      fname = row.payeeFirstName && row.payeeFirstName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      lname = row.payeeLastName && row.payeeLastName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      payee = row.representativePayee && row.representativePayee
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      date = row.enrollmentDate && row.enrollmentDate
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      time = row.achTime && row.achTime
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      updatedBy = row.updatedBy && row.updatedBy
      .toString()
      .toLowerCase()
      .includes(e.target.value.toString().toLowerCase());
      updatedDate = row.updatedDate && row.updatedDate
      .toString()
      .toLowerCase()
      .includes(e.target.value.toString().toLowerCase());

      if (fname) {
        searchValue = fname;
      } else if (payee) {
        searchValue = payee;
      } else if (date) {
        searchValue = date;
      } else if (time) {
        searchValue = time;
      } else if (updatedBy) {
        searchValue = updatedBy;
      } else if (updatedDate) {
        searchValue = updatedDate;
      } else {
        searchValue = lname;
      }

      return searchValue;
    });
    setRecords(newdatas);
    //setExportEnrolledData(newdatas);

    const dataToBeDownloaded = originalDownloadData && originalDownloadData.filter((row) => {
      setRstPagination(!resetPagination);
      fname = row.payeeFirstName && row.payeeFirstName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      lname = row.payeeLastName && row.payeeLastName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      payee = row.representativePayee && row.representativePayee
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      date = row.enrollmentDate && row.enrollmentDate
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      time = row.achTime && row.achTime
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      updatedBy = row.updatedBy && row.updatedBy
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      updatedDate = row.updatedDate && row.updatedDate
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());

      if (fname) {
        searchValue = fname;
      } else if (payee) {
        searchValue = payee;
      } else if (date) {
        searchValue = date;
      } else if (time) {
        searchValue = time;
      } else if (updatedBy) {
        searchValue = updatedBy;
      } else if (updatedDate) {
        searchValue = updatedDate;
      } else {
        searchValue = lname;
      }

      return searchValue;
    });
    setExportEnrolledData(dataToBeDownloaded);
  };

  const onClickBackButton = () => {
    navigate("/home");
  };

  const onClickNewButton = () => {
    navigate("/enrollment", {state: {routeName: location.pathname}});
  };
 
  return (
    <div>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
          </Backdrop>
        </>
      )}

      {/* <div className={records && records.length> 0 ?"data-container":"no-data-container"}> */}
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: ".5rem",
          }}
        >
          <h2 className="header">Direct Deposits Listing</h2>
          <div className="search-container">
            <TextField
              placeholder="Search"
              type="text"
              variant="outlined"
              margin="normal"
              onChange={handleChangeInput}
              //inputProps={{ className: "search-text" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>                                       
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
              }}
            />
          </div>
        </div>

        
        {/*<Grid
                  item
                  sx={{
                    p: "5px 16px",
                    border: "1.5px solid #dfe3e8",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    marginBottom: "5px"
                  }}
                >
                  <Stack
                    direction="row"
                    alignItems="left"
                    columnGap="2.5rem"
                    justifyContent="left"
                    sx={{ width: "100%", height: "50px", m: "5px 0" }}
                  >
                    <Box
                      display="flex"
                      sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <p className="input-label-carefacility">Care Facility</p>
                      <TextField
                        select
                        id="care-facility-list"
                        label=""
                        value={childCareFacility}
                        defaultValue="Select"
                        variant="outlined"
                        name="childCareFacility"
                        //onChange={onChangeFacility}
                        sx={{ minWidth: "200px", "& .MuiSelect-select":{ padding: "8px 14px !important"} }}
                        //className="facility-account"
                        SelectProps={{

                          MenuProps: {
                            PaperProps: {
                              style: {
                                maxHeight: 200,
                              },
                            },
                          },
                        }}
                      >
                      
                        <MenuItem key="Child1" value="Child1">Child1</MenuItem>
                        <MenuItem key="Child2" value="Child2">Child2</MenuItem>
                        <MenuItem key="Child3" value="Child3">Child3</MenuItem>
                        <MenuItem key="Child4" value="Child4">Child4</MenuItem>
                      </TextField>
                    </Box>
                   
                  </Stack>
        </Grid>*/}

        <DataTable
          title=""
          columns={columns(userAccessRole)}
          data={records}
          pagination
          striped
          progressPending={loading? true: false}
          highlightOnHover
          customStyles={customStyle}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          paginationResetDefaultPage={resetPagination}
          paginationPerPage={5}
          paginationComponentOptions={{
            rowsPerPageText: "Records per page",
            rangeSeparatorText: "Out of",
          }}
          expandableRows
          expandableRowsComponent={ExpandedComponent}
          expandableIcon={{
            collapsed: (
              <SvgIcon>
                <svg color="#002d82" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
                  />
                </svg>
              </SvgIcon>
            ),
            expanded: (
              <SvgIcon
                sx={{
                  color: "#002d82",
                }}
              >
                <svg viewBox="0 0 24 24" color="#002d82">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
                  />
                </svg>
              </SvgIcon>
            ),
          }}
        />
        <div className="button-container">
          <div className="left-btn-container">
            <Button
               className="back-btn"
              variant="outlined"
              onClick={onClickBackButton}
            >
              {" "}
              Back
            </Button>
            {userAccessRole === "Write" ?
            <Button
              className="download-btn"
              variant="contained"
              onClick={onClickNewButton}
            >
              {" "}
              New Enrollment
            </Button>
            : null}
          </div>
          <div>
             {/* <Button
              className="download-btn"
              variant="contained"
              onClick={onClickDownloadButton}
            >
              Download
            </Button>  */}
            {records && records.length ?
            <CustomExcelExport
              filename={`DirectDeposit-Listings.xlsx`}
              data={exportEnrolledData}
              headers={exportDirectDepositColumns}
              >
          </CustomExcelExport>
          :""}
          </div>
        </div>
      </div>
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}

export default DirectDepositListing;

const ExpandedComponent = ({ data }) => {
  return (
    <div
      style={{
        display: "grid",
        gridAutoFlow: "row",
        gap: "10px",
        padding: "20px",
      }}
    >
      <label style={{ fontWeight: "bold", color: "#002d82" }}>
        Benefits Enrolled
      </label>

      <div
        style={{
          display: "grid",
          gridAutoFlow: "row",
          gap: "10px",
          padding: "20px",
          color: "#002d82",
          backgroundColor: "#f2f2f2",
        }}
      >
        {data.benefitTypes.length &&
          data.benefitTypes.map((benefit, index) => (
            <span key={index}> {benefit}</span>
          ))}
      </div>      
    </div>
  );
};
